import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { OperatorSessionService } from '../services/operator-session/operator-session.service';
import { unidadePermitida } from '../utils/unidades-permitidas.util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService,
    private localStorageService: LocalStorageService,
    private operatorSessionService: OperatorSessionService,
  ) { }

  async canActivate(): Promise<boolean | UrlTree> {
    const token = this.userService.getTokenAuth();
    if (!token) return false;

    // Sessão aberta antes neste host (ex.: URL reaproveitada no piloto) com unidade fora da lista.
    const unidade = this.localStorageService.get('currentUnit');
    if (unidade == null || unidade === '' || unidadePermitida(unidade)) return true;

    try { await this.userService.logout(); } catch {}
    try { await this.operatorSessionService.endSession('logoff'); } catch {}
    this.localStorageService.clear();
    return this.router.parseUrl('/login');
  }
}
